import {observer} from 'mobx-react-lite'
import React from 'react'
import {ToolTipText} from '@components/common/base/tooltip/tooltip-text'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {MenuIconButton} from './menu-icon-button'

interface Props {
  className?: string
  hint?: string

  icon: TablerIcons
  onClick: () => void
  notification?: boolean
  active?: boolean
}

export const tooltipOffsetX = 0
export const tooltipOffsetY = -4

export const MenuIconButtonWithTooltip = observer((props: Props) => {
  const {hint, className} = props
  const {icon, onClick, notification, active} = props

  return (
    <div className={className}>
      <ToolTipText
        text={hint ?? ''}
        offsetX={tooltipOffsetX}
        offsetY={tooltipOffsetY}
      >
        <MenuIconButton
          icon={icon}
          onClick={onClick}
          notification={notification}
          active={active}
        />
      </ToolTipText>
    </div>
  )
})
